module.exports = __webpack_public_path__ + "static/media/enagic-img1.e8af4a99.png";